import { ReactNode, createContext, useState } from "react";
import { Answer } from "@coffee/data-access/api-types";

interface CurrentAnswerContextType {
  currentAnswer: Answer | null;
  setCurrentAnswer: (answer: Answer | null) => void;
}

export const CurrentAnswerContext = createContext<
  CurrentAnswerContextType | undefined
>(undefined);

export const CurrentAnswerProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [currentAnswer, setCurrentAnswer] = useState<Answer | null>(null);

  return (
    <CurrentAnswerContext.Provider value={{ currentAnswer, setCurrentAnswer }}>
      {children}
    </CurrentAnswerContext.Provider>
  );
};
